import api from '@/api';

export const tracersModel = {
    state: {
        data: {},
        error: false,
        loading: false,
    },
    reducers: {
        // Remove
        setTracers: (state, payload) => {
            return { ...state, data: { ...state.data, [payload.id]: payload.data } };
        },
        setError: (state, payload) => {
            return { ...state, error: payload };
        },
    },
    effects: dispatch => ({
        async loadTracers(wellId, rootState) {
            this.loading = true;
            try {
                const raw = await api.carottage.fetchTracers({ wellIds: [wellId] });

                let res = [];
                if (Array.isArray(raw[wellId])) {
                    res = raw[wellId];
                }

                this.setTracers({ id: wellId, data: res });
                this.loading = false;
            } catch (error) {
                this.setError(error);
                this.loading = false;
                console.log(error);
            }
        },
    }),
};
